import { useLocation } from '@reach/router'
import { withPrefix } from 'gatsby'

export function isLandingPage(pathname: string) {
  return pathname === withPrefix('/')
}

export function isDocsPage(pathname: string) {
  return pathname.startsWith(withPrefix('/docs/'))
}

export function useLocationChecker(checker: (pathname: string) => boolean): boolean {
  const location = useLocation()
  return checker(location.pathname)
}
